var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoxing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Boxing-Glove--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Boxing Glove Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.42 7.34A6.71 6.71 0 0 0 16.76 0h-5.71a4.51 4.51 0 0 0 -4.5 4.5v5a1.25 1.25 0 0 0 1.25 1.25h9.76A1.25 1.25 0 0 0 18.8 9.5V7a0.75 0.75 0 0 1 1.5 0v2.5a2.75 2.75 0 0 1 -2.75 2.75H7.79A2.75 2.75 0 0 1 5 9.5V5.74a0.51 0.51 0 0 0 -0.29 -0.45A3 3 0 0 0 3.61 5a2.71 2.71 0 0 0 -2.06 0.7 3.84 3.84 0 0 0 -1 2.8c0 5.82 3.2 7.74 4.68 8.31a0.51 0.51 0 0 1 0.32 0.47v4.22a2.5 2.5 0 0 0 2.5 2.5h10a2.5 2.5 0 0 0 2.5 -2.5v-6.24a1 1 0 0 1 0.29 -0.7c0.78 -0.79 2.16 -2.78 2.58 -7.22Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoxing);
export default ForwardRef;